import { render, staticRenderFns } from "./ClientesEvolucaoFaturamentoCliente.vue?vue&type=template&id=0a8a373c&scoped=true&"
import script from "./ClientesEvolucaoFaturamentoCliente.vue?vue&type=script&lang=js&"
export * from "./ClientesEvolucaoFaturamentoCliente.vue?vue&type=script&lang=js&"
import style0 from "./ClientesEvolucaoFaturamentoCliente.vue?vue&type=style&index=0&id=0a8a373c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a373c",
  null
  
)

export default component.exports